import { useTranslation } from 'react-i18next';

import { ConfirmationWarningDialog } from '@/components/dialogs';

import { useIsUploadConfirmationDialogOpen, useReconciliationFileStoreActions } from '../reconciliation-file.store';

type ReconciliationUploadConfirmationDialogProps = {
  onConfirm: () => void;
};

export const ReconciliationUploadConfirmationDialog = ({ onConfirm }: ReconciliationUploadConfirmationDialogProps) => {
  const { t } = useTranslation('orders-page');
  const isOpen = useIsUploadConfirmationDialogOpen();
  const { closeUploadConfirmationDialog } = useReconciliationFileStoreActions();

  const handleProceed = () => {
    closeUploadConfirmationDialog();
    onConfirm();
  };

  return (
    <ConfirmationWarningDialog
      open={isOpen}
      titleText={t('reconciliation.binding.dialogs.upload-confirmation.title')}
      contentText={t('reconciliation.binding.dialogs.upload-confirmation.content-text')}
      actionButtonText={t('reconciliation.binding.dialogs.upload-confirmation.action-button-text')}
      onProceed={handleProceed}
      onClose={closeUploadConfirmationDialog}
    />
  );
};
